import { render, staticRenderFns } from "./ClinicianPatientsNewResults.vue?vue&type=template&id=dd309b84"
import script from "./ClinicianPatientsNewResults.vue?vue&type=script&lang=js"
export * from "./ClinicianPatientsNewResults.vue?vue&type=script&lang=js"
import style0 from "./ClinicianPatientsNewResults.vue?vue&type=style&index=0&id=dd309b84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports